
import TradingBotStats from "@/models/TradingBotStats";
import Vue from "vue";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";

@Component
export default class TradingBotSearchBar extends Vue {
  // 📦 All the bots that are available for the selected section
  @Prop({ default: [] })
  public allSectionBots!: TradingBotStats[];

  // 📦 The bots which are filtered by the provided search
  @PropSync("filteredBots")
  public filteredSectionBots!: TradingBotStats[];

  // 📦 The search term/s the user provides in order to filter the available section bots
  private search: string | null = null;

  /**
   * 👂 Listener for changes in the section bots
   */
  @Watch("allSectionBots", { immediate: true })
  onSectionBotsChanged(val: TradingBotStats[], oldVal: TradingBotStats[]) {
    this.onChange(this.search);
  }

  /**
   * 👂 Listener for changes in the provided search term
   */
  @Watch("search", { immediate: true })
  private onSearchChanged(val: string, oldVal: string) {
    this.onChange(val);
  }

  /**
   * 🔨 General handler for changes that is triggered on data and seach changes
   */
  private onChange(search: string | null) {
    if (search === "" || search == null) {
      this.filteredSectionBots = this.allSectionBots;
    } else {
      this.filteredSectionBots = this.filterBySearchTerm(search);
    }
  }

  /**
   * 🔨 Filters all the bots based on the provided search term
   */
  private filterBySearchTerm(search: string): TradingBotStats[] {
    const filtered = this.allSectionBots.filter((bot: TradingBotStats) => {
      // Trunctate the search in case of multiple words
      var splitSearch = search
        .split(" ")
        .filter((search: string) => search !== "" && search !== " ");

      // The props the bot is going to get filtered
      var props = [
        bot.uid,
        bot.exchange,
        bot.market,
        bot.strategy_name,
        bot.candles,
      ];

      var counter = 0;

      splitSearch.forEach((searchTerm: string) => {
        // Find all the properties that include the searched term
        props.forEach((prop: any) => {
          if (prop != null) {
            counter += prop.toLowerCase().includes(searchTerm.toLowerCase())
              ? 1
              : 0;
          }
        });
      });
      return counter >= splitSearch.length;
    });
    return filtered;
  }
}
